import React, { ReactElement } from 'react';

import { Spinner } from '@components';

import EmptyLeadDataState, { LeadDataCardType } from '../EmptyLeadDataState';

interface AnalyticsCardStateProps {
  isLoading: boolean;
  hasData: boolean;
  emptyCardType: LeadDataCardType;
  children: ReactElement;
}

const AnalyticsCardState: React.FC<AnalyticsCardStateProps> = ({
  isLoading,
  hasData,
  emptyCardType,
  children
}) => {
  if (isLoading)
    return (
      <div className="flex flex-1 items-center justify-center py-20">
        <Spinner />
      </div>
    );
  if (!hasData) return <EmptyLeadDataState cardType={emptyCardType} />;
  return children;
};

export default AnalyticsCardState;
